export default __webpack_public_path__ + "static/media/usdt_logo.92d7fda4.svg";